import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { ReactSVG } from 'react-svg';
import moment from 'moment';

import { i18n as I18n } from 'utils/i18n';
import TimeSlot from '../timeSlot';

import { AVAILABILITY_STATUSES } from '../../constants/fieldData';

const SpaceTimeSlots = ({
  space,
  slots,
  onRemove,
  hasError,
  hasRecurrence,
  availability,
}) => {
  const classes = className({
    space: true,
    'space--error': hasError,
  });

  const costForSlot = (slot, occurrences) => {
    const hours =
      moment(slot.endTime, 'HH:mm').diff(
        moment(slot.startTime, 'HH:mm'),
        'minute',
        true
      ) / 60.0;

    return hours * space.priceIncVat * occurrences;
  };

  const renderSelectedSlots = () => {
    return slots.length ? (
      slots.map(slot => {
        const slotKey = `${slot.startTime}-${slot.endTime}`;
        const occurrences = availability[slotKey]
          ? availability[slotKey].filter(entry => entry.spaceId === space.id)
              .length
          : 1;

        return (
          <ul className="space__slots" key={slotKey}>
            <TimeSlot
              startTime={slot.startTime}
              endTime={slot.endTime}
              cost={costForSlot(slot, occurrences)}
              hasHelp={!!slot.combined}
              hasError={slot.available !== AVAILABILITY_STATUSES.AVAILABLE.flag}
              errorLabel={AVAILABILITY_STATUSES[slot.available].label}
            />
          </ul>
        );
      })
    ) : (
      <ul className="space__slots">
        <TimeSlot />
      </ul>
    );
  };

  return (
    <li className={classes} data-testid="spaceItem" data-cy="spaceItem">
      <div className="space__item space__details">
        <span className="space__name">
          {hasError && (
            <i
              className="fas fa-exclamation-triangle space__icon"
              data-testid="spaceListItemErrorIcon"
            />
          )}
          {space.name}
          {hasRecurrence && (
            <ReactSVG
              src="/images/icons/basket/recurring.svg"
              width={17}
              height={17}
            />
          )}
        </span>

        <button
          className="button button--small"
          onClick={onRemove}
          data-testid="quickBookRemoveSpace"
        >
          {I18n.t('quick_book.space.remove')}
        </button>
      </div>

      {renderSelectedSlots()}
    </li>
  );
};

SpaceTimeSlots.propTypes = {
  space: PropTypes.object.isRequired,
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      startTime: PropTypes.string,
      endTime: PropTypes.string,
      available: PropTypes.string,
    })
  ),
  onRemove: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  hasRecurrence: PropTypes.bool,
  availability: PropTypes.object,
};

SpaceTimeSlots.defaultProps = {
  slots: [],
  hasError: false,
  hasRecurrence: false,
  availability: {},
};

export default SpaceTimeSlots;
